import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useManageSegmentStore } from "./store";
import CardDiv from "modules/common/card-div/CardDiv";
import SoftBadge from "modules/common/SoftBadge";
import { Image } from "antd";
import NoData from "assets/svgs/no_data/NoData";
import { Placeholder } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function SegmentDetail() {
  const { segmentId, segmentName } = useParams();
  const { segmentContentData, segmentComponentLoading, fetchSegmentContent } =
    useManageSegmentStore();
  const [content, setContent] = useState([]);
  const navigate=useNavigate();


  useEffect(() => {
    if (segmentContentData?.data) {
      setContent(segmentContentData?.data?.[0]);
    }
  }, [segmentContentData]);

  useEffect(() => {
    fetchSegmentContent(segmentId);
  }, [segmentId]);

  const handleContent = (key) => {
    setContent(segmentContentData?.data[key]);
  };

  const handleBack=()=>{
    navigate("/manage-segments");
  }

  return (
    <div>
      <CardDiv
        title={
          <div className="d-flex gap-3">
            <button className="btn btn-primary" onClick={handleBack}>Back</button>
            <div className="fs-2">{segmentName}</div>
          </div>
        }
        component={
          <div style={{ maxHeight: "78vh", top: 20 }}>
            <div className="d-flex">
              <div
                style={{
                  width: "33%",
                  transition: "width 0.3s ease, opacity 0.3s ease",
                  overflow: "hidden",
                  height: "75vh",
                  overflowY: "scroll",
                }}
                className="scrollable-container"
              >
                <div
                  className="d-flex rounded-top p-3  "
                  style={{
                    background: "#F9FAFD",
                    position: "sticky",
                    top: "0",
                    height: "4rem",
                  }}
                >
                  <span className="flex-2 fw-bold">Display Title</span>
                  <span className="flex-1 fw-bold">Type</span>
                  <span className="flex-1 fw-bold">Order</span>
                </div>
                {segmentComponentLoading ? (
                  <>
                    <Placeholder as="p" animation="glow">
                      <Placeholder xs={12} />
                    </Placeholder>
                    <Placeholder as="p" animation="glow">
                      <Placeholder xs={12} />
                    </Placeholder>
                  </>
                ) : (
                  segmentContentData?.data?.map((item, index) => {
                    return (
                      <div className="d-flex p-3 border rounded" key={item?.id}>
                        <span
                          className="flex-2 text-primary py-3 fw-bold cursor-pointer"
                          onClick={() => handleContent(index)}
                        >
                          {item?.display_title}
                        </span>
                        <span className="flex-1 text-black py-3">
                          {item?.type === "custom" ? (
                            <SoftBadge bg="success" className="me-2 fw-bold ">
                              {item?.type}
                            </SoftBadge>
                          ) : item?.type === "video" ? (
                            <SoftBadge bg="warning" className="me-2 fw-bold ">
                              {item?.type}
                            </SoftBadge>
                          ) : (
                            <SoftBadge bg="info" className="me-2 fw-bold ">
                              {item?.type}
                            </SoftBadge>
                          )}
                        </span>
                        <span className="flex-1 text-black ps-3 py-3">
                          {item?.order}
                        </span>
                      </div>
                    );
                  })
                )}
              </div>
              <div
                style={{
                  height: "79vh",
                  width: "67%",
                  transition: "width 0.3s ease",
                  overflow: "auto",
                  overflowY: "scroll",
                }}
                className="flex-fill ms-3 card scrollable-container"
              >
                <div className="border rounded scrollable-container">
                  <div
                    className="p-3 d-flex gap-3 bg-white border "
                    style={{
                      background: "#F9FAFD",
                      position: "sticky",
                      top: "0",
                      zIndex: "999",
                      height: "4rem",
                    }}
                  >
                    <div className="">
                      <span className="fw-bold">Display Title </span>:{" "}
                      <SoftBadge bg="success" className="me-2">
                        <span style={{ fontSize: "16px" }}>
                          {content?.display_title}
                        </span>
                      </SoftBadge>
                    </div>
                    <div>
                      <span className="fw-bold"> Display Name</span> :{" "}
                      <SoftBadge bg="info" className="me-2">
                        <span style={{ fontSize: "16px" }}>
                          {content?.display_name}
                        </span>
                      </SoftBadge>
                    </div>
                  </div>
                  <div className="d-flex flex-wrap  gap-3 p-2 border">
                    {content?.contents?.length ? (
                      <Image.PreviewGroup>
                        {content?.contents?.map((image, index) => (
                          <div
                            className="border cardp-3 p-3 border rounded scrollable-container"
                            style={{ width: "17vw" }}
                          >
                            <div>
                              <Image
                                style={{ width: "15vw", height: "24rem" }}
                                className="bg-secondary rounded text-center border"
                                src={image?.standardAttributes?.backgroundImage}
                              />
                            </div>
                            <div className="mt-2">
                              <span className="fw-bold"> Subject:</span>{" "}
                              {image?.standardAttributes?.subject}
                            </div>
                            <div className="mt-2">
                              <span className="fw-bold"> Sub Text: </span>{" "}
                              {image?.standardAttributes?.subText}
                            </div>
                            <div className="mt-2">
                              <span className="fw-bold"> Content Link: </span>
                              {image?.componentAttributes?.contentLink}
                            </div>
                            <div className="mt-2">
                              <span className="fw-bold"> Display Name: </span>
                              {image?.displayName}
                            </div>
                            <div className="mt-2">
                              <span className="fw-bold"> Type: </span>
                              {image?.type}
                            </div>
                            <div className="mt-2">
                              <span className="fw-bold"> Is Active: </span>
                              {image?.isActive}
                            </div>
                            <div className="mt-2">
                              <span className="fw-bold">
                                Background Image Link:{" "}
                              </span>
                              <a
                                href={image?.standardAttributes?.backgroundImage}
                                target="blank"
                              >
                                Image Url
                              </a>
                            </div>
                          </div>
                        ))}
                      </Image.PreviewGroup>
                    ) : (
                      <div className="fs-1" style={{ marginLeft: "40%" }}>
                        Data not available <NoData />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
}

export default SegmentDetail;
